import { imagesBcp } from '@assets';

import { AppTheme } from './types';

export const appThemeBcp: AppTheme = {
	images: {
		warningIcon: {
			src: imagesBcp.warningIcon,
			height: '100px',
			width: '100px',
		},
		bcpRound: {
			src: imagesBcp.bcpRound,
			height: '40px',
			width: '40px',
		},
	},
	colors: {
		profileBackground: '#d1005d',
	},
};
